import * as Yup from 'yup'

export interface ValidationMessages {
  general: string
  [key: string]: string
}

export const validationSchema = (messages: ValidationMessages) =>
  Yup.object().shape({
    insurances: Yup.array().of(
      Yup.object().shape({
        carrierId: Yup.string().required(messages.general),
        categoryId: Yup.string().required(messages.general),
      }),
    ),
  })
